import { Card, CardContent } from '@mui/material'
import { FC, ReactNode } from 'react'

type KanbanItemProps = {
  item: Record<string, any>
  color: string
  cardContentRenderProp: (props: Record<string, any>) => ReactNode
}

export const KanbanItem: FC<KanbanItemProps> = ({
  item,
  color,
  cardContentRenderProp
}) => {
  return (
    <Card
      sx={{
        width: '200px',
        borderLeft: `2px solid ${color}`
      }}
    >
      <CardContent>{cardContentRenderProp({ item })}</CardContent>
    </Card>
  )
}
